import type {FC} from 'react';
import {
  Box,
  Icon,
  IconNames,
  Stack,
  Typography,
} from '@wellstone-solutions/web';
import {Theme} from '@wellstone-solutions/common';
import {GroupEventContent} from './GroupEventContent';
import type {UICalendarEventType} from '@wellstone-solutions/common';
import {Participants} from '../CalendarEvent';
import {ActionButton} from './ActionButton';

interface GroupEventModalContentProps {
  calendarEvent: UICalendarEventType;
}

export const GroupEventModalContent: FC<GroupEventModalContentProps> = ({
  calendarEvent,
}) => {
  const hasDescription = calendarEvent.data.notes?.length > 0;
  return (
    <Stack
      direction="column"
      spacing={2}
      sx={{color: Theme.colorPalette.darkest}}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Box sx={styles.icon}>
          <Icon name={IconNames.Community} />
        </Box>
        <Stack direction="column" sx={{flex: 1, ml: 2}}>
          <Typography variant="h6">{calendarEvent.title}</Typography>
          <Typography sx={{textTransform: 'uppercase', fontSize: 14}}>
            Group Meeting
          </Typography>
        </Stack>

        <ActionButton group={calendarEvent.group} />
      </Stack>
      {hasDescription && <Typography>{calendarEvent.data.notes}</Typography>}
      <Stack direction="row">
        <GroupEventContent calendarEvent={calendarEvent} direction="column" />
      </Stack>
      <Typography
        sx={{
          fontWeight: 'bold',
          fontSize: 16,
        }}>{`Attendees (${Math.max(
        calendarEvent.invitations.length - 1,
        0,
      )})`}</Typography>
      <Participants
        invitations={calendarEvent.invitations}
        calendarEvent={calendarEvent}
        isOwner={calendarEvent.isOwner}
        hideIsAttending={true}
      />
    </Stack>
  );
};

const styles = {
  icon: {
    width: 55,
    height: 55,
    p: 1.5,
    pt: 1.75,
    borderRadius: 10,
    textAlign: 'center',
    backgroundColor: Theme.colorPalette.primary4,
    borderColor: Theme.colorPalette.primary4,
    color: Theme.colorPalette.primary,
  },
};
